const SyncOriginType = {
  AUTOMATIC: "typeOfSyncOrigin.automatic",
  MANUAL: "typeOfSyncOrigin.manual",
};

export { SyncOriginType };
